//hmac加密
import hMacAjax from "./hMacFetch";
//携带cookie
import tokenAjax from "./tokenFetch";
//不携带cookie请求 - 用于请求华为云接口
import noTokenAjax from "./noTokenFetch";

//@0.0.26
//调整返回形式为对象
//对外不抛出outRequest、httpAjax
//修改hmac加密 - as/sk取值逻辑
const request = hMacAjax.request;

export default {
  request,
  hMacAjax,
  tokenAjax,
  noTokenAjax,
};

export { request, hMacAjax, tokenAjax, noTokenAjax };
